import React from "react";

import "./assets/css/style.css";

function ItemBox(props: any) {
  function openBox(e: any) {
    var siblings = e.target.parentNode.childNodes;
    for (var z = 0; z < siblings.length; z++) {
      if (
        siblings[z].nodeType === 1 &&
        (siblings[z].classList.contains("groups__list") ||
          siblings[z].classList.contains("groups__form"))
      ) {
        siblings[z].classList.toggle("groups__item--open");
        e.target.classList.toggle("box--active");
      }
    }
  }

  return (
    <div
      onClick={openBox}
      className={props.className ? `box ${props.className}` : "box"}
    >
      <span className="box__text">{props.name}</span>
      {props.children}
    </div>
  );
}

export default ItemBox;
